module.exports = __webpack_public_path__ + "img/ubicacion.63b0a19e.svg";